<div
  (mousedown.capture)="onPanelMouseDown($event)"
  [class.aria-panel--double]="doubleCalendar()"
  class="aria-panel"
  tabindex="-1"
>

  <div class="aria-panel__header">

    <button (click)="previousPage()" aria-label="Precedente" class="aria-panel__nav" type="button">

      ‹

    </button>


    <div class="aria-panel__title" id="aria-panel-title">

      @if (panelView() === 'days' && enableYearMonthNavigation() && !doubleCalendar()) {

        <button (click)="showMonthView()" class="aria-panel__title-btn" type="button">

          {{ displayViewMonth().format('MMMM') }}

        </button>

        <button (click)="showYearView()" class="aria-panel__title-btn" type="button">

          {{ displayViewMonth().format('YYYY') }}

        </button>

      } @else {

      <span>{{ headerTitle() }}</span>

    }

    </div>


    <button (click)="nextPage()" aria-label="Successivo" class="aria-panel__nav" type="button">

      ›

    </button>

  </div>


  @if (panelView() === 'years') {

    <table

      [enableSelection]="true"

      aria-labelledby="aria-panel-title"

      class="aria-panel__picker-grid"

      ngGrid

      role="grid"

      selectionMode="explicit"

    >

      <tbody>

      @for (row of yearRows(); track rowIndex; let rowIndex = $index) {

        <tr [rowIndex]="rowIndex" ngGridRow>

          @for (year of row; track year.key; let colIndex = $index) {

            <td

              (selectedChange)="onYearSelectedChange($event, year)"

              [colIndex]="colIndex"

              [disabled]="year.disabled"

              [rowIndex]="rowIndex"

              [selectable]="!year.disabled"

              [selected]="year.selected"

              class="aria-panel__picker-cell-host"

              ngGridCell

            >

              <button

                [attr.aria-pressed]="year.selected"

                [class.aria-panel__picker-cell--selected]="year.selected"

                [class.aria-panel__picker-cell--today]="year.today"

                [disabled]="year.disabled"

                class="aria-panel__picker-cell"

                ngGridCellWidget

                type="button"

                widgetType="simple"

              >

                {{ year.label }}

              </button>

            </td>

          }

        </tr>

      }

      </tbody>

    </table>

  } @if (panelView() === 'months') {

  <table

    [enableSelection]="true"

    aria-labelledby="aria-panel-title"

    class="aria-panel__picker-grid aria-panel__picker-grid--months"

    ngGrid

    role="grid"

    selectionMode="explicit"

  >

    <tbody>

    @for (row of monthRows(); track rowIndex; let rowIndex = $index) {

      <tr [rowIndex]="rowIndex" ngGridRow>

        @for (month of row; track month.key; let colIndex = $index) {

          <td

            (selectedChange)="onMonthSelectedChange($event, month)"

            [colIndex]="colIndex"

            [disabled]="month.disabled"

            [rowIndex]="rowIndex"

            [selectable]="!month.disabled"

            [selected]="month.selected"

            class="aria-panel__picker-cell-host"

            ngGridCell

          >

            <button

              [attr.aria-pressed]="month.selected"

              [class.aria-panel__picker-cell--selected]="month.selected"

              [class.aria-panel__picker-cell--today]="month.today"

              [disabled]="month.disabled"

              class="aria-panel__picker-cell"

              ngGridCellWidget

              type="button"

              widgetType="simple"

            >

              {{ month.label }}

            </button>

          </td>

        }

      </tr>

    }

    </tbody>

  </table>

} @if (panelView() === 'days') {

  <div

    [class.aria-panel__calendars--double]="doubleCalendar()"

    class="aria-panel__calendars"

  >

    <div class="aria-panel__calendar">

      @if (doubleCalendar()) {

        <p class="aria-panel__month-caption">{{ displayViewMonth().format('MMMM YYYY') }}</p>

      }

      <ng-container *ngTemplateOutlet="daysGrid; context: { weeks: weeks(), calendarMonth: displayViewMonth() }"/>

    </div>


    @if (doubleCalendar()) {

      <div class="aria-panel__calendar">

        <p class="aria-panel__month-caption">{{ secondaryViewMonth().format('MMMM YYYY') }}</p>

        <ng-container *ngTemplateOutlet="daysGrid; context: { weeks: secondaryWeeks(), calendarMonth: secondaryViewMonth() }"/>

      </div>

    }

  </div>

}

</div>


<ng-template #daysGrid let-weeks="weeks" let-calendarMonth="calendarMonth">

  <table
    (keydown.capture)="onDaysGridArrowKeydown($event)"
    (keydown)="onDaysGridKeydown($event)"
    [attr.data-calendar-month]="calendarMonth.format('YYYY-MM')"
    [class.aria-calendar__grid--range-picking]="isRangePicking()"
    [colWrap]="'nowrap'"
    [enableSelection]="true"
    [rowWrap]="'nowrap'"
    class="aria-calendar__grid"
    ngGrid
    selectionMode="explicit"
  >

    <thead>

    <tr>

      @for (weekDay of weekDays; track weekDay) {

        <th class="aria-calendar__weekday" scope="col">

          {{ weekDay }}

        </th>

      }

    </tr>

    </thead>

    <tbody>

    @for (week of weeks; track week.id; let weekIndex = $index) {

      <tr [rowIndex]="weekIndex" ngGridRow>

        @for (day of week.days; track day.key; let colIndex = $index) {

          @if (day.hidden) {
            <td
              [colIndex]="colIndex"
              [disabled]="true"
              [rowIndex]="weekIndex"
              [selectable]="false"
              aria-hidden="true"
              class="aria-calendar__cell aria-calendar__cell--empty"
              ngGridCell
            ></td>
          } @else {
          <td

            [attr.data-day-key]="day.key"

            [class.aria-calendar__cell--in-range]="day.inRange"

            [class.aria-calendar__cell--outside]="!day.inMonth"

            [class.aria-calendar__cell--range-end]="day.rangeEnd"

            [class.aria-calendar__cell--range-start]="day.rangeStart"

            [class.aria-calendar__cell--today]="day.today"

            [colIndex]="colIndex"

            [disabled]="day.disabled"

            [rowIndex]="weekIndex"

            [selectable]="!day.disabled"

            [selected]="day.selected"

            class="aria-calendar__cell"

            ngGridCell

          >

            <button

              (click)="onDayClick($event, day)"

              (focus)="onDayHover(day)"

              (keydown)="onDayKeydown($event, day)"

              (mouseenter)="onDayHover(day)"

              (mouseleave)="clearDayHover()"

              (pointerdown)="$event.stopPropagation()"

              [attr.aria-label]="dayButtonLabel(day)"

              [attr.aria-pressed]="day.selected"

              [disabled]="day.disabled"

              class="aria-calendar__day"

              ngGridCellWidget

              type="button"

              widgetType="simple"

            >

              {{ day.label }}

            </button>

          </td>
          }

        }

      </tr>

    }

    </tbody>

  </table>

</ng-template>


